import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { FeaturesServices } from "../api";

const onDefaultError = (error) => {
  toast.error(error.message);
};
/**
 * Hook for Admin Organisation States Master section
 */
const useListFeatures = ([page_no], onSuccess, onError = onDefaultError) => {
  return useQuery(["features-list", page_no], FeaturesServices.featuresList, {
    onSuccess,
    keepPreviousData: true,
    onError,
  });
};
const useAddFeatures = (onSuccess, onError = onDefaultError) => {
  return useMutation(FeaturesServices.addFeatures, {
    onSuccess,
    onError,
  });
};
const useFeaturesDelete = (onSuccess, onError = onDefaultError) => {
  return useMutation(FeaturesServices.deleteFeatures, {
    onSuccess,
    onError,
  });
};
const useUpdateFeatures = (onSuccess, onError = onDefaultError) => {
  return useMutation(FeaturesServices.updateFeatures, {
    onSuccess,
    onError,
  });
};
const useViewFeatures = (id, onSuccess, onError = onDefaultError) => {
  return useQuery(
    "features-view",
    () => FeaturesServices.viewFeatures({ id }),
    {
      onSuccess,
      onError,
    }
  );
};
const useFeaturesStatusChange = (onSuccess, onError = onDefaultError) => {
  return useMutation(FeaturesServices.updateStatusFeatures, {
    onSuccess,
    onError,
  });
};

export {
  useListFeatures,
  useAddFeatures,
  useFeaturesDelete,
  useUpdateFeatures,
  useViewFeatures,
  useFeaturesStatusChange,
};
